<!-- 荣誉证书 -->

<template>
  <div class="certificate-of-honor">
    <img
      style="min-width: 1500px; max-width: 1900px; width: 100%"
      v-for="(img, idx) in images"
      :key="idx"
      :src="img"
      :alt="'荣誉证书' + (idx + 1)"
      class="certificate-img"
    />
  </div>
</template>

<script setup>
const images = [
  require("@/assets/CertificateOfHonor/CertificateOfHonor01.png"),
  require("@/assets/CertificateOfHonor/CertificateOfHonor02.png"),
  require("@/assets/CertificateOfHonor/CertificateOfHonor03.png"),
  require("@/assets/CertificateOfHonor/CertificateOfHonor04.png"),
  require("@/assets/CertificateOfHonor/CertificateOfHonor05.png"),
];
</script>

<style scoped>
.certificate-of-honor {
}
</style>
